/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
	// Add custom code below this line

	// ProductPriceSync v1.0
	class ZapietProductPriceSync {
		/**
		 * @param {Object} opts
		 * @param {string} opts.rootSelector
		 * @param {string} opts.btnPriceSelector
		 * @param {string} opts.priceIdPrefix
		 * @param {string} opts.zapietContainerSelector
		 */
		constructor(opts = {}) {
			this.cfg = Object.assign(
				{
					rootSelector: 'product-info[data-section]',
					btnPriceSelector: 'button[type="submit"] .btn__price',
					priceIdPrefix: 'Price-',
					zapietContainerSelector: '.zapiet-option-container',
				},
				opts
			);

			this._rafId = null;
			this._onChange = this._onChange.bind(this);
			this._onInput = this._onInput.bind(this);
			this._captureOpts = { capture: true, passive: true };

			this._mounted = false;
		}

		mount() {
			if (this._mounted) return;

			document.addEventListener('change', this._onChange, this._captureOpts);
			document.addEventListener('input', this._onInput, this._captureOpts);

			this._mounted = true;

			this.scheduleSync();
		}

		destroy() {
			if (!this._mounted) return;

			document.removeEventListener('change', this._onChange, this._captureOpts);
			document.removeEventListener('input', this._onInput, this._captureOpts);

			this._mounted = false;

			if (this._rafId) cancelAnimationFrame(this._rafId);

			this._rafId = null;
		}

		scheduleSync() {
			if (this._rafId) return;

			this._rafId = requestAnimationFrame(() => {
				this._rafId = null;
				this.sync();
			});
		}

		sync() {
			const root = document.querySelector(this.cfg.rootSelector);
			if (!root) return;

			const sectionId = root.getAttribute('data-section');
			if (!sectionId) return;

			const priceEl = document.getElementById(`${this.cfg.priceIdPrefix}${sectionId}`);
			const btnPrice = root.querySelector(this.cfg.btnPriceSelector);
			if (!priceEl || !btnPrice) return;

			const next = (priceEl.textContent || '').trim();
			if (!next) return;

			const curr = (btnPrice.textContent || '').trim();
			if (curr !== next) btnPrice.textContent = next;
		}

		_isZapietTarget(t) {
			return !!(t && t.closest && t.closest(this.cfg.zapietContainerSelector));
		}

		_onChange(e) {
			if (this._isZapietTarget(e.target)) this.scheduleSync();
		}
		_onInput(e) {
			if (this._isZapietTarget(e.target)) this.scheduleSync();
		}

		static auto(opts = {}) {
			if (!window.theme?.isProductPage) return;

			const inst = new ZapietProductPriceSync(opts);

			if (document.readyState === 'loading') {
				document.addEventListener('DOMContentLoaded', () => inst.mount(), { once: true });
			} else {
				inst.mount();
			}

			window.__ZapietProductPriceSync = inst;

			return inst;
		}
	}

	ZapietProductPriceSync.auto({
		rootSelector: 'product-info[data-section]',
		btnPriceSelector: 'button[type="submit"] .btn__price',
		priceIdPrefix: 'Price-',
		zapietContainerSelector: '.zapiet-option-container',
	});

	// ^^ Keep your scripts inside this IIFE function call to
	// avoid leaking your variables into the global scope.
})();
